import { render, staticRenderFns } from "./BulkImportHistory.vue?vue&type=template&id=7e28ea1c&scoped=true"
import script from "./BulkImportHistory.vue?vue&type=script&lang=js"
export * from "./BulkImportHistory.vue?vue&type=script&lang=js"
import style0 from "./BulkImportHistory.vue?vue&type=style&index=0&id=7e28ea1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e28ea1c",
  null
  
)

export default component.exports